import script from "./ProductDemo16167.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductDemo16167.vue?vue&type=script&setup=true&lang=ts"

import "./ProductDemo16167.vue?vue&type=style&index=0&id=038e1641&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-038e1641"]])

export default __exports__